var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('Form',{attrs:{"editing":true}}),_c('br')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }